import styled from 'styled-components';

export const TooltipContentWrapper = styled.span`
  /* without this display property ContentWrapper might have
   * height inconsistency issues (it could take up more height
   * than its children's)
   */
  display: inline-flex;
`;
